import * as types from "./types";

export const defaultState = {
  products: {},
  selected_products: {},
  fetching_session_id: false,
  request_types: {
    fetching: false,
  },
  sharing_boxes: {},
  errors: [],
};

const prypool_products = (state = defaultState, action) => {
  switch (action.type) {
    case types.FETCHING_SESSION_ID:
      return {
        ...state,
        fetching_session_id: true
      }
    case types.FETCHED_SESSION_ID:
      return {
        ...state,
        fetching_session_id: false
      }
    case types.FETCHING_PRYPOOL_PRODUCTS:
    case types.FETCHING_SHARING_BOX:
      return {
        ...state,
        request_types: { ...state.request_types, fetching: true }
      }
    case types.FETCHED_PRYPOOL_PRODUCTS:
      return {
        ...state,
        products: action.products,
        request_types: { ...state.request_types, fetching: false }
      }
    case types.FETCHED_SHARING_BOX:
      return {
        ...state,
        sharing_boxes: { ...state.sharing_boxes, [action.sharingBox.object.slug]: action.sharingBox.object },
        request_types: { ...state.request_types, fetching: false }
      }
    case types.PUSH_PRYPOOL_SELECTED_PRODUCT:
      return {
        ...state,
        selected_products: { ...state.selected_products, [action.product.id]: action.product }
      }
    case types.REMOVE_PRYPOOL_SELECTED_PRODUCT:
      let selected_products = { ...state.selected_products };
      delete selected_products[action.product.id]
      return {
        ...state,
        selected_products: selected_products
      }

    case types.ERROR_FETCHING_PRYPOOL_PRODUCTS:
      return {
        ...state,
        errors: [...state.errors, action.error],
        loading: defaultState.request_types,
        request_types: {
          fetching: false,
        }
      }
    case types.ERROR_FETCHING_SESSION_ID:
      return {
        ...state,
        fetching_session_id: false
      }
    default:
      return state;
  }
};
export default prypool_products;
